import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "./adminpanel.css";
import Router from "./Router/Router";
import { useButtonHoverEffect } from "./helper/useButtonHoverEffect";
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './context/AuthContext';


function App() {
  useButtonHoverEffect();

  return (
    <div className="App">
      <ToastContainer />
      <AuthProvider>
        <Router />
      </AuthProvider>
    </div>
  )
}

export default App;
